export type LanguageCode = 'en' | 'zh';
export type TranslationDictionary = Record<string, string>;
export type Translations = Record<LanguageCode, TranslationDictionary>;

export const translations: Translations = {
	en: {
		panelTitle: 'aliofficials Panel',
		admin: 'Admin',
		navNotes: 'Collaborative Notes',
		notesNew: 'New Note',
		notesUntitled: 'Untitled note',
		notesSearch: 'Search notes...',
		notesShowArchived: 'Show archived',
		notesHideArchived: 'Hide archived',
		notesEmpty: 'No notes yet',
		notesNoResults: 'No notes match your search',
		notesCreateFirst: 'Create your first note',
		notesSelectPrompt: 'Select a note or create a new one',
		notesTitlePlaceholder: 'Note title',
		notesTitleRequired: 'A title is required',
		notesSaving: 'Saving…',
		notesSaved: 'Saved',
		notesSaveFailed: 'Save failed',
		notesLastUpdated: 'Last updated {time} by {user}',
		notesYou: 'you',
		notesUnknownUser: 'unknown',
		notesLoadError: 'Failed to load notes',
		notesRetry: 'Retry',
		notesCreateError: 'Failed to create note',
		notesRenameError: 'Failed to rename note',
		notesActionError: 'Action failed',
		notesContentTooLarge: 'Note content is too large to save',
		notesArchived: 'Note archived',
		notesUnarchived: 'Note restored',
		notesArchive: 'Archive',
		notesUnarchive: 'Restore',
		notesDeleted: 'Note deleted',
		notesDeletedElsewhere: 'This note was deleted in another session',
		notesDeleteConfirm: 'This will permanently delete "{name}". This action cannot be undone.',
		notesUpdatedElsewhere: 'This note was updated elsewhere. Reload to see the latest version.',
		notesReloadLatest: 'Reload latest',
		notesUnsavedTitle: 'Unsaved changes',
		notesUnsavedBody: 'You have unsaved changes. Discarding will lose them.',
		notesDiscardSwitch: 'Discard & switch',
		signOut: 'Sign Out',
		settings: 'Settings',
		darkModeEnabled: 'Dark mode enabled',
		lightModeEnabled: 'Light mode enabled',
		languageEnglish: 'Language set to English',
		languageChinese: 'Language set to Chinese (Simplified)',
		navDashboard: 'Dashboard',
		navDb: 'db',
		navAddProduct: 'Add Product',
		dashboard: 'Dashboard',
		welcome: 'Welcome to your aliofficials admin dashboard',
		addProduct: 'Add Product',
		totalDb: 'Total db',
		recentDb: 'Recent db',
		latestDb: 'Latest db added to the system',
		viewAll: 'View All',
		noDbFound: 'No db found',
		uncategorized: 'Uncategorized',
		addedDate: 'Added',
		inventory: 'Inventory',
		manageClothing: 'Manage your clothing items',
		addNewItem: 'Add New Item',
		loadingItems: 'Loading items...',
		showingItemsOf: 'Showing {count} of {total} items',
		searchItems: 'Search items...',
		clear: 'Clear',
		reorder: 'Reorder',
		reordering: 'Reordering...',
		saveOrder: 'Save order',
		noItemsFound: 'No items found',
		tryDifferentFilters: 'Try different filter settings or clear all filters',
		getStartedAddingItem: 'Get started by adding your first item',
		clearAllFilters: 'Clear All Filters',
		order: 'Order',
		name: 'Name',
		brand: 'Brand',
		category: 'Category',
		price: 'Price',
		actions: 'Actions',
		areYouSure: 'Are you sure?',
		deleteItemConfirm: 'This will permanently delete the item "{name}". This action cannot be undone.',
		cancel: 'Cancel',
		delete: 'Delete',
		deleting: 'Deleting...',
		itemsPerPage: 'Items per page:',
		showingXOfYItems: 'Showing {count} of {total} items',
		pageLabel: 'Page {page}',
		jumpToPage: 'Jump to page...',
		go: 'Go',
		visitProductPage: 'Visit product page',
		manageShoes: 'Manage your shoe items',
		addNewShoe: 'Add New Shoe',
		loadingShoes: 'Loading shoes...',
		showingShoesOf: 'Showing {count} of {total} shoes',
		searchShoes: 'Search shoes...',
		noShoesFound: 'No shoes found',
		getStartedAddingShoe: 'Get started by adding your first shoe',
		enterCredentials: 'Enter your credentials to access the admin dashboard',
		email: 'Email',
		password: 'Password',
		signIn: 'Sign In',
		signingIn: 'Signing in...',
		pleaseEnterEmailPassword: 'Please enter both email and password',
		editItemTitle: 'Edit Item',
		addItemTitle: 'Add New Item',
		editItemSubtitle: 'Update item details and images',
		addItemSubtitle: 'Add a new item to your inventory',
		tabDetails: 'Item Details',
		tabImages: 'Images',
		tabPreview: 'Preview',
		basicInformation: 'Basic Information',
		basicInformationDesc: 'Enter the basic details about the item',
		labelName: 'Name',
		placeholderProductName: 'Product name',
		labelPrice: 'Price ($)',
		placeholderPrice: '0.00',
		labelBrand: 'Brand',
		placeholderBrand: 'Enter brand name',
		labelSearchAliases: 'Search aliases',
		placeholderSearchAliases: 'e.g. BK, Birk (comma-separated)',
		searchAliasesHint: 'Optional nicknames that help shoppers find this item (max 200 characters).',
		searchCurateTitle: 'Search suggestions',
		searchCurateDescription: 'Curate synonyms, ALI Recommend terms, and promoted items for the public search dropdown.',
		searchCurateTrendingTitle: 'Trending searches',
		searchCurateTrendingDescription: 'Auto-filled from analytics when terms clear privacy thresholds. Hide junk terms with the blacklist — new valid trends still appear automatically.',
		searchCurateTrendingNote: 'Public terms require count ≥ 3 and distinct sessions ≥ 2 over 7 days, exclude zero-result-only queries, and skip blacklisted terms. Hiding a term frees its slot for the next eligible search.',
		searchCurateTrendingLive: 'Currently eligible',
		searchCurateTrendingHidden: 'Hidden (blacklist)',
		searchCurateTrendingHide: 'Hide',
		searchCurateTrendingUnhide: 'Unhide',
		searchCurateTrendingReset: 'Reset trending to default',
		searchCurateTrendingResetHint: 'Clears your blacklist and reloads the latest analytics ranking.',
		searchCurateTrendingResetDone: 'Trending blacklist cleared',
		searchCurateTrendingHiddenDone: 'Trending term hidden',
		searchCurateTrendingUnhiddenDone: 'Trending term restored',
		searchCurateTrendingCounts: 'searches / sessions',
		searchCurateTrendingEmptyLive: 'No trending terms meet the threshold right now.',
		searchCurateTrendingEmptyHidden: 'No hidden terms.',
		searchCurateDropdownSettings: 'Dropdown controls',
		searchCurateDropdownSettingsDesc: 'Turn the public search dropdown on/off, toggle sections, and set section order.',
		searchCurateDropdownEnabled: 'Show search dropdown',
		searchCurateDropdownEnabledHint: 'When off, focusing the search bar will not open suggestions.',
		searchCurateSectionOrder: 'Section order & visibility',
		searchCurateSectionOrderHint: 'Use the arrows to reorder sections on the public site.',
		searchCurateSortOrder: 'Order',
		searchCuratePoolHint: 'Multi-product pool (one random pick per visitor session)',
		searchCurateRecommendPoolHint: 'Add multiple products. Each visitor sees one random pick from this pool for the session.',
		searchCuratePromotedPoolHint: 'Add multiple promoted products. Each visitor sees one random pick from this pool for the session.',
		searchCurateSettingsSaved: 'Dropdown settings saved',
		searchCurateSynonyms: 'Synonyms',
		searchCurateRecommend: 'ALI Recommend',
		searchCuratePromoted: 'Promoted',
		searchCurateAddSynonym: 'Add synonym',
		searchCurateSynonymHint: 'Example: bk → birkenstock applies to every matching product.',
		searchCurateAlias: 'Alias',
		searchCurateExpansion: 'Expands to',
		searchCurateQuery: 'Search query',
		searchCurateAddRecommend: 'Add recommend term',
		searchCurateAddPromoted: 'Add promoted item',
		searchCuratePromotedHint: 'Search the catalog, then pick a product to feature in the dropdown.',
		searchCurateProductSearch: 'Find product',
		searchCurateSelectedProduct: 'Selected product id',
		searchCurateEmpty: 'No entries yet',
		searchCurateLoadError: 'Failed to load search curation data',
		searchCurateSaveError: 'Failed to save search curation change',
		searchCurateSynonymSaved: 'Synonym saved',
		searchCurateRecommendSaved: 'Recommend term saved',
		searchCuratePromotedSaved: 'Promoted item saved',
		searchCurateDeleted: 'Deleted',
		searchCurateRefresh: 'Refresh',
		searchCurateAdd: 'Add',
		searchCurateEnabled: 'Enabled',
		labelProductLink: 'Product Link',
		placeholderProductLink: 'https://example.com/product',
		original: 'Original',
		labelOrder: 'Order',
		placeholderOrder: '1',
		labelCategory: 'Category',
		selectCategory: 'Select category',
		btnCancel: 'Cancel',
		btnNextUploadImages: 'Next: Upload Images',
		itemImage: 'Item Image',
		itemImageDesc: 'Upload an image for this item.',
		clickToUpload: 'Click to upload',
		orDragAndDrop: 'or drag and drop',
		uploadFormats: 'PNG, JPG or GIF (Max size: 5MB)',
		uploadedImage: 'Uploaded Image',
		noImageUploaded: 'No image uploaded',
		uploadNewOrKeepExisting: 'Upload a new image or keep the existing one',
		back: 'Back',
		btnNextPreviewItem: 'Next: Preview Item',
		itemPreview: 'Item Preview',
		itemPreviewDesc: 'See how your item will appear in the catalog',
		checkout: 'Check Out',
		previewDetails: 'Preview Details',
		nameLabel: 'Name:',
		brandLabel: 'Brand:',
		notSpecified: 'Not specified',
		priceLabel: 'Price:',
		categoryLabel: 'Category:',
		batchQualityLabel: 'Batch Quality:',
		affiliateLinkLabel: 'Affiliate Link:',
		linkLabel: 'Link:',
		noteAffiliateFailed: 'Note: Affiliate conversion failed. Using original link.',
		updating: 'Updating...',
		creating: 'Creating...',
		updateItem: 'Update Item',
		createItem: 'Create Item',
		loadingItemDetails: 'Loading item details...',
		createdByLabel: 'Created by:',
		createdAtLabel: 'Created:',
		lastUpdatedLabel: 'Last updated:',
		toastBrandsFailed: 'Failed to load brand suggestions',
		toastItemLoadFailed: 'Failed to load item details',
		itemSavedCreated: 'Item created successfully',
		itemSavedUpdated: 'Item updated successfully',
		failedToSaveItem: 'Failed to save item. Please try again.',
		validationNameRequired: 'Name is required',
		validationPriceGreater: 'Price must be greater than 0',
		validationCategoryRequired: 'Category is required',
		validationImageRequired: 'Image is required for new items',
		navAnalyticsAgents: 'Agent Analytics',
		navAnalyticsProducts: 'Product Analytics',
		navAnalyticsDiscovery: 'Discovery Analytics',
		navAnalyticsReliability: 'Reliability Analytics',
		navAnalyticsCreators: 'Creator Analytics',
		navCreators: 'Creator Codes',
		navAnalyticsGroup: 'Analytics',
		navCreatorsGroup: 'Creators',
		navOperations: 'Operations',
		roleOwner: 'Owner',
		roleWorker: 'Worker',
		operationsTitle: 'Operations',
		operationsDescription: 'Safe catalog diagnostics, filtered downloads, and affiliate link testing. No bulk or destructive actions.',
		operationsRefresh: 'Refresh data',
		operationsRetry: 'Retry',
		operationsLoadError: 'Failed to load catalog data.',
		operationsTotalProducts: 'Total products',
		operationsProductsWithIssues: 'Products with issues',
		operationsDuplicateLinks: 'Duplicate links',
		operationsMissingAffiliates: 'Missing affiliate links',
		operationsMissingImages: 'Missing images',
		operationsInvalidPrices: 'Invalid prices',
		operationsExportTitle: 'Filter and download',
		operationsExportDescription: 'Downloads are created in your browser and are not stored in Supabase.',
		operationsSearchPlaceholder: 'Search name, ID, brand, category, or link',
		operationsAllBrands: 'All brands',
		operationsAllCategories: 'All categories',
		operationsMinPrice: 'Minimum price',
		operationsMaxPrice: 'Maximum price',
		operationsMatched: '{count} matched',
		operationsIssuesTitle: 'Catalog quality results',
		operationsIssuesDescription: 'The table shows up to 100 matching rows. Downloads include every matching row.',
		operationsProduct: 'Product',
		operationsBrand: 'Brand',
		operationsIssues: 'Issues',
		operationsAction: 'Action',
		operationsUnnamed: 'Unnamed product',
		operationsNoIssues: 'No issues',
		operationsEdit: 'Edit',
		operationsNoMatches: 'No products match these filters.',
		operationsTableLimit: 'Only the first 100 rows are shown here. Your download still includes all matched rows.',
		operationsConvertTitle: 'Affiliate link tester',
		operationsConvertDescription: 'Runs the existing conversion service without saving changes to a product.',
		operationsConvert: 'Test link',
		operationsConverting: 'Testing...',
		operationsConvertResult: 'Conversion result',
		operationsConvertEmpty: 'The conversion service returned no links.',
		operationsConvertError: 'Link conversion failed.',
		operationsCopy: 'Copy',
		operationsCopied: 'Conversion result copied.',
		operationsIssueAll: 'All products',
		operationsIssueMissingName: 'Missing name',
		operationsIssueMissingBrand: 'Missing brand',
		operationsIssueMissingLink: 'Missing product link',
		operationsIssueMissingPrice: 'Missing price',
		operationsIssueMissingCategory: 'Missing category',
		operationsIssueMissingImage: 'Missing image',
		operationsIssueInvalidPrice: 'Invalid price',
		operationsIssueDuplicateName: 'Duplicate name',
		operationsIssueDuplicateLink: 'Duplicate Weidian link',
		operationsIssueDuplicateOrder: 'Duplicate order',
		operationsIssueMissingAffiliates: 'Missing affiliate links',
		navSearchSuggestions: 'Search suggestions',
		creatorsTitle: 'Creator Codes',
		creatorsDescription: 'Create and manage unique invite codes so you can measure the traffic and engagement each content creator brings.',
		creatorCreateTitle: 'Create a creator code',
		creatorCreateDescription: 'Codes are lowercase and 3-32 characters (letters, numbers, hyphen, underscore). Share the generated link with the creator.',
		creatorCodeLabel: 'Code',
		creatorCodePlaceholder: 'e.g. jane01',
		creatorCodeHint: 'Lowercase letters, numbers, hyphen or underscore. 3-32 characters.',
		creatorLabelLabel: 'Label (optional)',
		creatorLabelPlaceholder: 'Creator name or note',
		creatorCreate: 'Create code',
		creatorCreating: 'Creating...',
		creatorCreated: 'Creator code created',
		creatorInvalidFormat: 'Creator codes must be 3-32 characters using lowercase letters, numbers, hyphen or underscore.',
		creatorListTitle: 'Creator codes',
		creatorListDescription: 'Enable or disable codes and copy shareable links. Disabling stops future attribution only; past credited events stay credited.',
		creatorRefresh: 'Refresh',
		creatorTableCode: 'Code',
		creatorTableLabel: 'Label',
		creatorTableStatus: 'Status',
		creatorTableCreated: 'Created',
		creatorTableUpdated: 'Updated',
		creatorTableShare: 'Share link',
		creatorTableFilters: 'Filters',
		creatorCopyLink: 'Copy share link',
		creatorLinkCopied: 'Share link copied',
		creatorCopyFailed: 'Could not copy link',
		creatorEnabled: 'Enabled',
		creatorDisabled: 'Disabled',
		creatorEnabledToast: 'Creator code enabled',
		creatorDisabledToast: 'Creator code disabled',
		creatorSave: 'Save',
		creatorSaved: 'Label updated',
		creatorUpdateFailed: 'Failed to update creator code',
		creatorLoadFailed: 'Failed to load creator codes',
		creatorEmptyDescription: 'No creator codes yet. Create one above to start attributing traffic.',
		creatorAnalyticsTitle: 'Creator Analytics',
		creatorAnalyticsDescription: 'Full-funnel, first-party attribution for each creator code: sessions, page views, and downstream catalog engagement.',
		creatorDisclaimerTitle: 'How to read these numbers',
		creatorDisclaimerServerEntries: 'Server entry metrics count eligible visits through /c/ links. Recognizable previews and bots are excluded, but sophisticated bots may remain.',
		creatorDisclaimerFirstParty: 'Browser sessions and downstream engagement are browser-observed first-party analytics.',
		creatorDisclaimerBrowserGap: 'Browser-attributed counts can be lower when analytics is blocked or a visitor leaves before the page loads.',
		creatorDisclaimerRedirects: 'Shopping-agent redirect analytics remains separate from creator entry traffic.',
		creatorDisclaimerPurchases: 'Purchases and revenue are not available.',
		creatorMetricServerEntrySessions: 'Server entry sessions',
		creatorMetricServerEntrySessionsDescription: 'Distinct browser-session cookies observed through creator /c/ links.',
		creatorMetricServerEntrySessionSum: 'Per-creator entry sessions (sum)',
		creatorMetricServerEntrySessionSumDescription: 'Sum of each creator row; one browser can count once for more than one creator.',
		creatorMetricServerEntryRequests: 'Server entry requests',
		creatorMetricServerEntryRequestsDescription: 'Accepted creator-link requests after short duplicate suppression.',
		creatorMetricSessions: 'Attributed sessions',
		creatorMetricSessionsDescription: 'Distinct browser sessions that entered with an enabled creator code.',
		creatorMetricPageViews: 'Page views',
		creatorMetricPageViewsDescription: 'First-party page views across public pages from attributed sessions.',
		creatorMetricProductClicks: 'Product clicks',
		creatorMetricProductClicksDescription: 'Product link and image clicks from attributed sessions.',
		creatorMetricAffiliateClicks: 'Affiliate clicks',
		creatorMetricAffiliateClicksDescription: 'Agent button clicks from attributed sessions (clicks, not confirmed sales).',
		creatorChartTitle: 'Top creators by attributed sessions',
		creatorChartDescription: 'Creators bringing the most distinct sessions in the selected window.',
		creatorTablePerformanceTitle: 'Creator performance',
		creatorTablePerformanceDescription: 'Enabled creators with no activity are shown so you can tell "no traffic yet" from missing setup.',
		creatorStatusUnregistered: 'Unregistered',
		creatorEmptyTitle: 'No creator codes yet',
		creatorReportEmptyDescription: 'Create a creator code and share its link to start collecting attributed traffic.',
		creatorNoActivityYet: 'No attributed activity in this window yet.',
		creatorTableAgents: 'Agent overrides',
		creatorConfigureAgents: 'Configure agents',
		creatorAgentDialogTitle: 'Agent affiliate overrides — {code}',
		creatorAgentDialogDescription: 'Set per-agent affiliate codes for this creator. Only an enabled override with a valid code replaces the ALI Officials default; every other agent keeps the default. Affiliate codes are resolved server-side.',
		creatorPreferredAgentLabel: 'Preferred default agent',
		creatorPreferredAgentHint: 'Auto-selected for visitors who arrive via this creator and have not chosen an agent. Works best when paired with an enabled override for the same agent.',
		creatorPreferredAgentNone: 'No preference',
		creatorAgentColumn: 'Agent',
		creatorAgentCodeColumn: 'Affiliate code',
		creatorAgentEnabledColumn: 'Override enabled',
		creatorAgentCodePlaceholder: 'Creator affiliate code',
		creatorAgentSaved: 'Agent overrides saved',
		creatorAgentInvalidCode: 'Affiliate codes must be 1-64 characters using letters, numbers, hyphen or underscore.',
		creatorAgentEnabledNeedsCode: 'Enter an affiliate code before enabling that agent override.',
		creatorPreferredNeedsOverride: 'Heads up: the preferred agent has no enabled affiliate override, so it will fall back to the ALI Officials default code.',
		creatorCancel: 'Cancel',
		creatorSaveChanges: 'Save changes',
		creatorSaving: 'Saving...',
		dashboardLoading: 'Loading dashboard data...',
		dashboardCatalogLoadFailed: 'Failed to load dashboard catalog data',
		analyticsLoadFailed: 'Failed to load analytics data',
		analyticsBusinessOverview: 'Business overview',
		analyticsBusinessOverviewDescription: 'First-party interaction metrics from the approved Analytics V1 RPCs.',
		analyticsCatalogOverview: 'Catalog overview',
		analyticsCatalogOverviewDescription: 'Current product inventory and recent additions.',
		analyticsDateRange: 'Analytics date range',
		analyticsUtcRange: 'UTC range: {range}',
		analyticsPriorUtcRange: 'Prior UTC range: {range}',
		analyticsComparedWithPrior: 'Compared with prior period',
		analyticsComparisonNew: 'new',
		analyticsComparisonNoBaseline: 'no prior baseline',
		analyticsLoading: 'Loading analytics data...',
		analyticsErrorTitle: 'Analytics unavailable',
		analyticsRetry: 'Retry',
		analyticsRefresh: 'Refresh',
		analyticsAutoRefreshHint: 'Live — updates automatically',
		analyticsNoEventsTitle: 'No events yet',
		analyticsNoEventsDescription: 'No first-party analytics events were returned for this date range.',
		analyticsNoProductEventsDescription: 'No product click events were returned for this date range.',
		analyticsNoDiscoveryEventsDescription: 'No search, filter, or feed-status events were returned for this date range.',
		analyticsNoReliabilityEventsDescription: 'No server-observed redirect events were returned for this date range.',
		analyticsAffiliateClicks: 'Affiliate clicks',
		analyticsAffiliateClicksDescription: 'Client-observed clicks on enabled agent affiliate buttons.',
		analyticsBrowserAffiliateClicks: 'Browser affiliate clicks',
		analyticsBrowserAffiliateClicksDescription: 'Browser-observed affiliate button clicks. These are not the same as server-observed redirect requests.',
		analyticsAgentSelections: 'Agent selections',
		analyticsAgentSelectionsDescription: 'How often shoppers selected an agent in the public catalog.',
		analyticsTopClickedAgent: 'Top clicked agent',
		analyticsTopClickedAgentDescription: 'Ranked by affiliate-click events, not purchases or confirmed conversions.',
		analyticsTopSelectedAgent: 'Top selected agent',
		analyticsTopSelectedAgentDescription: 'Ranked by agent selection events before any click happens.',
		analyticsZeroResultRate: 'Zero-result rate',
		analyticsZeroResultRateDescription: 'Zero-result searches divided by total sanitized search events.',
		analyticsFeedStatus: 'Feed status',
		analyticsFeedStatusHealthy: 'No failures',
		analyticsFeedStatusWarning: 'Failures seen',
		analyticsFeedStatusUnknown: 'No signal',
		analyticsFeedStatusHealthyDescription: 'No product-feed failures were captured in this range.',
		analyticsFeedStatusWarningDescription: 'One or more product-feed failure events were captured.',
		analyticsFeedStatusUnknownDescription: 'No first-party events exist in this range, so feed health is not verified.',
		analyticsAgentsTitle: 'Agent analytics',
		analyticsAgentsDescription: 'Compare selected-agent intent against clicked-agent behavior.',
		analyticsClicksByAgent: 'Affiliate clicks by agent',
		analyticsClicksByAgentDescription: 'Client-observed affiliate clicks grouped by clicked agent.',
		analyticsSelectionShare: 'Agent selection share',
		analyticsSelectionShareDescription: 'Selected-agent share from agent_selected events.',
		analyticsAgentRanking: 'Agent ranking',
		analyticsAgentRankingDescription: 'Selections and clicks are separate signals and should not be treated as conversions.',
		analyticsAgent: 'Agent',
		analyticsSelectedShare: 'Selected share',
		analyticsSelections: 'Selections',
		analyticsClickedShare: 'Clicked share',
		analyticsClicks: 'Clicks',
		analyticsProductsTitle: 'Product analytics',
		analyticsProductsDescription: 'Rank product click activity with bounded name and category enrichment.',
		analyticsProductClicks: 'Product clicks',
		analyticsProductClicksDescription: 'Client-observed product link opens. Product impressions are not available yet.',
		analyticsTopClickedProduct: 'Top clicked product',
		analyticsTopClickedProductDescription: 'Ranked by product-click count in the selected range.',
		analyticsNoCtrTitle: 'CTR deferred',
		analyticsCountsOnly: 'Counts only',
		analyticsNoCtrDescription: 'Product impressions are deferred, so this MVP does not show product CTR.',
		analyticsTopProductsChart: 'Top clicked products',
		analyticsTopProductsChartDescription: 'Product-click counts by enriched product name where available.',
		analyticsProductRanking: 'Product ranking',
		analyticsProductRankingDescription: '{count} products were enriched by one bounded db lookup.',
		analyticsProduct: 'Product',
		analyticsDiscoveryTitle: 'Discovery analytics',
		analyticsDiscoveryDescription: 'Search and filter aggregates from sanitized first-party events.',
		analyticsSearches: 'Searches',
		analyticsSearchesDescription: 'Sanitized search events captured after the shopper settles a query.',
		analyticsTopSearch: 'Top search',
		analyticsTopSearchDescription: 'Most frequent sanitized search term in this range.',
		analyticsTopMissedDemand: 'Top missed demand',
		analyticsTopMissedDemandDescription: 'Most frequent sanitized zero-result search term.',
		analyticsTopSearches: 'Top sanitized searches',
		analyticsTopSearchesDescription: 'Search terms are truncated and redacted before storage.',
		analyticsFilterUsage: 'Category and filter usage',
		analyticsFilterUsageDescription: 'Filter_applied event counts by category or filter dimension.',
		analyticsFilterEvents: 'Filter events',
		analyticsNoSearchesTitle: 'No searches',
		analyticsNoSearchesDescription: 'No sanitized search terms were returned for this range.',
		analyticsNoFiltersTitle: 'No filter usage',
		analyticsNoFiltersDescription: 'No filter_applied events were returned for this range.',
		analyticsMissedDemand: 'Missed-demand searches',
		analyticsMissedDemandDescription: 'Sanitized searches that returned zero results.',
		analyticsFeedAndErrors: 'Feed and client signals',
		analyticsFeedAndErrorsDescription: 'Product-feed failures and sampled client-error aggregates.',
		analyticsFeedFailurePrefix: 'Feed failure',
		analyticsClientErrorPrefix: 'Client error',
		analyticsSearchTerm: 'Search term',
		analyticsZeroResultSearches: 'Zero-result searches',
		analyticsSignal: 'Signal',
		analyticsEvents: 'Events',
		analyticsNoRowsTitle: 'No rows',
		analyticsNoRowsDescription: 'No aggregate rows were returned for this section.',
		analyticsReliabilityTitle: 'Reliability analytics',
		analyticsReliabilityDescription: 'Server-observed redirect requests and failures from the affiliate redirect API.',
		analyticsReliabilityNote: 'Browser-observed affiliate clicks, server-observed redirect requests, redirect failures, and confirmed third-party purchases are different signals. Confirmed purchases remain unavailable.',
		analyticsRedirectRequests: 'Redirect requests',
		analyticsRedirectRequestsDescription: 'Server-observed redirect requests that successfully generated a third-party redirect response.',
		analyticsRedirectFailures: 'Redirect failures',
		analyticsRedirectFailuresDescription: 'Redirect requests that returned a non-redirect API failure response.',
		analyticsRedirectFailureRate: 'Redirect failure rate',
		analyticsRedirectFailureRateDescription: 'Server-observed redirect failures divided by total redirect requests.',
		analyticsConfirmedPurchases: 'Confirmed purchases',
		analyticsConfirmedPurchasesDescription: 'Third-party purchase confirmation is not available in this analytics system.',
		analyticsUnavailable: 'Unavailable',
		analyticsRedirectRequestsByAgent: 'Redirect requests by agent',
		analyticsRedirectRequestsByAgentDescription: 'Server-observed redirect responses grouped by requested agent route.',
		analyticsRedirectFailuresByStatus: 'Redirect failures by status',
		analyticsRedirectFailuresByStatusDescription: 'HTTP status codes returned when redirect generation failed.',
		analyticsRedirectFailuresByAgent: 'Redirect failures by agent',
		analyticsRedirectFailuresByAgentDescription: 'Agents associated with failed redirect responses.',
		analyticsRedirectFailuresByMarketplace: 'Redirect failures by marketplace',
		analyticsRedirectFailuresByMarketplaceDescription: 'Marketplaces associated with failed redirect responses.',
		analyticsRedirectFailuresByStage: 'Redirect failures by stage',
		analyticsRedirectFailuresByStageDescription: 'Failure stage buckets from the redirect handler.',
		analyticsMarketplace: 'Marketplace',
		analyticsFailureStage: 'Failure stage',
		cloudflareTitle: 'Cloudflare traffic metrics',
		cloudflareDescription: 'Cloudflare-observed HTTP traffic for the public zone. Loads independently from first-party site events below.',
		cloudflareFetching: 'Fetching Cloudflare analytics data...',
		cloudflareLoaded: 'Cloudflare analytics loaded',
		cloudflareLoadFailed: 'Failed to load Cloudflare analytics data',
		cloudflareCorsToast: 'Cloudflare analytics could not be loaded from this browser.',
		cloudflareCorsMessage: 'Browser security restriction (CORS). Cloudflare analytics is unavailable.',
		cloudflareRefresh: 'Refresh Cloudflare analytics',
		cloudflareErrorTitle: 'Cloudflare unavailable',
		cloudflareUnavailableTitle: 'Cloudflare analytics not configured',
		cloudflareUnavailableDescription: 'Set the Cloudflare edge-function secrets to enable this traffic card. First-party analytics can still be used.',
		cloudflareCorsDetail: 'The first-party analytics dashboard can still be used while Cloudflare is unavailable.',
		cloudflarePageViews: 'Page views',
		cloudflareVisits: 'Visits',
		cloudflareUniqueVisitors: 'Unique visitors',
		cloudflarePageViewsDefinition: 'Cloudflare page views for the selected UTC window.',
		cloudflareVisitsDefinition: 'Cloudflare visits for the selected UTC window, aggregated from end-user eyeball traffic.',
		cloudflareUniqueVisitorsDefinition: 'Cloudflare unique visitors for the selected UTC window. Multi-day totals sum daily values.',
		cloudflareInfrastructureRequests: 'Edge requests (infrastructure)',
		cloudflareInfrastructureDefinition: 'All HTTP requests through Cloudflare, including assets, bots, and platform traffic. Not a visitor metric.',
		cloudflareTotalRequests: 'Total requests',
		cloudflareRequests: 'Requests',
		cloudflareTopCountries: 'Top countries',
		cloudflareDateWindow: 'UTC window: {start} to {end}',
		cloudflareLastRange: 'Last {range}',
		cloudflareTrendsTitle: 'Traffic trends',
		cloudflareNoPageViews: 'No page view data available for this period',
		cloudflareNoVisits: 'No visit data available for this period',
		cloudflareNoUniqueVisitors: 'No unique visitor data available for this period',
		cloudflareNoCountries: 'No country data available for this period',
		cloudflareNoData: 'No Cloudflare analytics data available',
		cloudflareMetricSource: 'Source: Cloudflare zone analytics (GraphQL)',
	},
	zh: {
		panelTitle: 'aliofficials 管理面板',
		admin: '管理员',
		navNotes: '协作笔记',
		notesNew: '新建笔记',
		notesUntitled: '未命名笔记',
		notesSearch: '搜索笔记…',
		notesShowArchived: '显示已归档',
		notesHideArchived: '隐藏已归档',
		notesEmpty: '暂无笔记',
		notesNoResults: '没有匹配的笔记',
		notesCreateFirst: '创建你的第一条笔记',
		notesSelectPrompt: '选择一条笔记或新建一条',
		notesTitlePlaceholder: '笔记标题',
		notesTitleRequired: '标题不能为空',
		notesSaving: '正在保存…',
		notesSaved: '已保存',
		notesSaveFailed: '保存失败',
		notesLastUpdated: '最后由 {user} 更新于 {time}',
		notesYou: '你',
		notesUnknownUser: '未知',
		notesLoadError: '加载笔记失败',
		notesRetry: '重试',
		notesCreateError: '创建笔记失败',
		notesRenameError: '重命名笔记失败',
		notesActionError: '操作失败',
		notesContentTooLarge: '笔记内容过大，无法保存',
		notesArchived: '笔记已归档',
		notesUnarchived: '笔记已恢复',
		notesArchive: '归档',
		notesUnarchive: '恢复',
		notesDeleted: '笔记已删除',
		notesDeletedElsewhere: '该笔记已在其他会话中被删除',
		notesDeleteConfirm: '这将永久删除“{name}”。此操作无法撤销。',
		notesUpdatedElsewhere: '该笔记已在别处更新。重新加载以查看最新版本。',
		notesReloadLatest: '重新加载最新版本',
		notesUnsavedTitle: '未保存的更改',
		notesUnsavedBody: '你有未保存的更改，放弃后将会丢失。',
		notesDiscardSwitch: '放弃并切换',
		signOut: '退出登录',
		settings: '设置',
		darkModeEnabled: '深色模式已启用',
		lightModeEnabled: '浅色模式已启用',
		languageEnglish: '语言已切换为英文',
		languageChinese: '语言已切换为简体中文',
		navDashboard: '仪表盘',
		navDb: '数据库',
		navAddProduct: '添加商品',
		dashboard: '仪表盘',
		welcome: '欢迎使用 aliofficials 管理仪表盘',
		addProduct: '添加商品',
		totalDb: '数据库总数',
		recentDb: '最近数据库',
		latestDb: '最新添加的数据库',
		viewAll: '查看全部',
		noDbFound: '未找到数据',
		uncategorized: '未分类',
		addedDate: '添加时间',
		inventory: '库存',
		manageClothing: '管理你的服饰商品',
		addNewItem: '新增商品',
		loadingItems: '正在加载商品...',
		showingItemsOf: '显示 {count} / 共 {total} 个商品',
		searchItems: '搜索商品...',
		clear: '清除',
		reorder: '排序',
		reordering: '排序中...',
		saveOrder: '保存排序',
		noItemsFound: '未找到商品',
		tryDifferentFilters: '尝试不同的筛选条件或清除全部筛选',
		getStartedAddingItem: '从添加第一个商品开始吧',
		clearAllFilters: '清除所有筛选',
		order: '序号',
		name: '名称',
		brand: '品牌',
		category: '类别',
		price: '价格',
		actions: '操作',
		areYouSure: '确定吗？',
		deleteItemConfirm: '此操作将永久删除商品“{name}”，无法撤销。',
		cancel: '取消',
		delete: '删除',
		deleting: '正在删除...',
		itemsPerPage: '每页数量：',
		showingXOfYItems: '显示 {count} / 共 {total} 个',
		pageLabel: '第 {page} 页',
		jumpToPage: '跳转到页码...',
		go: '前往',
		visitProductPage: '访问商品页面',
		manageShoes: '管理你的鞋类商品',
		addNewShoe: '新增鞋类',
		loadingShoes: '正在加载鞋类...',
		showingShoesOf: '显示 {count} / 共 {total} 个鞋类',
		searchShoes: '搜索鞋类...',
		noShoesFound: '未找到鞋类',
		getStartedAddingShoe: '从添加第一双鞋开始吧',
		enterCredentials: '输入凭证以访问管理仪表盘',
		email: '邮箱',
		password: '密码',
		signIn: '登录',
		signingIn: '正在登录...',
		pleaseEnterEmailPassword: '请输入邮箱和密码',
		editItemTitle: '编辑商品',
		addItemTitle: '新增商品',
		editItemSubtitle: '更新商品详情和图片',
		addItemSubtitle: '向库存中添加新商品',
		tabDetails: '商品详情',
		tabImages: '图片',
		tabPreview: '预览',
		basicInformation: '基础信息',
		basicInformationDesc: '输入该商品的基础信息',
		labelName: '名称',
		placeholderProductName: '商品名称',
		labelPrice: '价格（$）',
		placeholderPrice: '0.00',
		labelBrand: '品牌',
		placeholderBrand: '输入品牌名称',
		labelSearchAliases: '搜索别名',
		placeholderSearchAliases: '例如 BK, Birk（逗号分隔）',
		searchAliasesHint: '可选昵称，帮助买家搜到该商品（最多 200 字符）。',
		searchCurateTitle: '搜索建议',
		searchCurateDescription: '管理同义词、ALI 推荐词与推广商品，用于前台搜索下拉。',
		searchCurateTrendingTitle: '热门搜索',
		searchCurateTrendingDescription: '在满足隐私阈值后由分析数据自动填充。可用黑名单隐藏无效词；新的有效热词仍会自动出现。',
		searchCurateTrendingNote: '公开词条需 7 天内次数 ≥ 3 且独立会话 ≥ 2，排除仅零结果词，并跳过黑名单。隐藏后空位由下一名合格搜索词补上。',
		searchCurateTrendingLive: '当前合格词',
		searchCurateTrendingHidden: '已隐藏（黑名单）',
		searchCurateTrendingHide: '隐藏',
		searchCurateTrendingUnhide: '取消隐藏',
		searchCurateTrendingReset: '重置热门为默认',
		searchCurateTrendingResetHint: '清空黑名单并重新加载最新统计排名。',
		searchCurateTrendingResetDone: '热门黑名单已清空',
		searchCurateTrendingHiddenDone: '已隐藏该热词',
		searchCurateTrendingUnhiddenDone: '已恢复该热词',
		searchCurateTrendingCounts: '搜索次数 / 会话数',
		searchCurateTrendingEmptyLive: '当前没有达到阈值的热词。',
		searchCurateTrendingEmptyHidden: '暂无隐藏词。',
		searchCurateDropdownSettings: '下拉菜单控制',
		searchCurateDropdownSettingsDesc: '开关前台搜索下拉、各分区显示，并调整分区顺序。',
		searchCurateDropdownEnabled: '显示搜索下拉',
		searchCurateDropdownEnabledHint: '关闭后，聚焦搜索框不会弹出建议。',
		searchCurateSectionOrder: '分区顺序与显示',
		searchCurateSectionOrderHint: '用箭头调整前台分区顺序。',
		searchCurateSortOrder: '顺序',
		searchCuratePoolHint: '多商品池（每位访客会话随机展示 1 个）',
		searchCurateRecommendPoolHint: '可添加多个商品。每位访客在本会话中只会随机看到其中一个。',
		searchCuratePromotedPoolHint: '可添加多个推广商品。每位访客在本会话中只会随机看到其中一个。',
		searchCurateSettingsSaved: '下拉设置已保存',
		searchCurateSynonyms: '同义词',
		searchCurateRecommend: 'ALI 推荐',
		searchCuratePromoted: '推广商品',
		searchCurateAddSynonym: '添加同义词',
		searchCurateSynonymHint: '例如：bk → birkenstock，会作用于所有匹配商品。',
		searchCurateAlias: '别名',
		searchCurateExpansion: '扩展为',
		searchCurateQuery: '搜索词',
		searchCurateAddRecommend: '添加推荐词',
		searchCurateAddPromoted: '添加推广商品',
		searchCuratePromotedHint: '搜索目录后选择要在下拉中展示的商品。',
		searchCurateProductSearch: '查找商品',
		searchCurateSelectedProduct: '已选商品 ID',
		searchCurateEmpty: '暂无条目',
		searchCurateLoadError: '加载搜索配置失败',
		searchCurateSaveError: '保存搜索配置失败',
		searchCurateSynonymSaved: '同义词已保存',
		searchCurateRecommendSaved: '推荐词已保存',
		searchCuratePromotedSaved: '推广商品已保存',
		searchCurateDeleted: '已删除',
		searchCurateRefresh: '刷新',
		searchCurateAdd: '添加',
		searchCurateEnabled: '启用',
		labelProductLink: '商品链接',
		placeholderProductLink: 'https://example.com/product',
		original: '原始链接',
		labelOrder: '序号',
		placeholderOrder: '1',
		labelCategory: '类别',
		selectCategory: '选择类别',
		btnCancel: '取消',
		btnNextUploadImages: '下一步：上传图片',
		itemImage: '商品图片',
		itemImageDesc: '为该商品上传图片。',
		clickToUpload: '点击上传',
		orDragAndDrop: '或拖拽到此处',
		uploadFormats: 'PNG、JPG 或 GIF（最大 5MB）',
		uploadedImage: '已上传图片',
		noImageUploaded: '尚未上传图片',
		uploadNewOrKeepExisting: '上传新图片或保留现有图片',
		back: '返回',
		btnNextPreviewItem: '下一步：预览商品',
		itemPreview: '商品预览',
		itemPreviewDesc: '查看商品在目录中的展示效果',
		checkout: '查看',
		previewDetails: '预览详情',
		nameLabel: '名称：',
		brandLabel: '品牌：',
		notSpecified: '未指定',
		priceLabel: '价格：',
		categoryLabel: '类别：',
		batchQualityLabel: '批次质量：',
		affiliateLinkLabel: '推广链接：',
		linkLabel: '链接：',
		noteAffiliateFailed: '注意：推广转换失败，将使用原始链接。',
		updating: '更新中...',
		creating: '创建中...',
		updateItem: '更新商品',
		createItem: '创建商品',
		loadingItemDetails: '正在加载商品详情...',
		createdByLabel: '创建者：',
		createdAtLabel: '创建时间：',
		lastUpdatedLabel: '最后更新：',
		toastBrandsFailed: '加载品牌建议失败',
		toastItemLoadFailed: '加载商品详情失败',
		itemSavedCreated: '商品创建成功',
		itemSavedUpdated: '商品更新成功',
		failedToSaveItem: '保存失败，请重试。',
		validationNameRequired: '名称为必填项',
		validationPriceGreater: '价格必须大于 0',
		validationCategoryRequired: '类别为必选项',
		validationImageRequired: '新建商品必须上传图片',
		navAnalyticsAgents: '代理分析',
		navAnalyticsProducts: '商品分析',
		navAnalyticsDiscovery: '发现分析',
		navAnalyticsReliability: '可靠性分析',
		navAnalyticsCreators: '创作者分析',
		navCreators: '创作者代码',
		navAnalyticsGroup: '分析',
		navCreatorsGroup: '创作者',
		navOperations: '运营工具',
		roleOwner: '所有者',
		roleWorker: '工作人员',
		operationsTitle: '运营工具',
		operationsDescription: '安全的商品诊断、筛选下载和联盟链接测试，不包含批量或破坏性操作。',
		operationsRefresh: '刷新数据',
		operationsRetry: '重试',
		operationsLoadError: '无法加载商品数据。',
		operationsTotalProducts: '商品总数',
		operationsProductsWithIssues: '存在问题的商品',
		operationsDuplicateLinks: '重复链接',
		operationsMissingAffiliates: '缺少联盟链接',
		operationsMissingImages: '缺少图片',
		operationsInvalidPrices: '无效价格',
		operationsExportTitle: '筛选并下载',
		operationsExportDescription: '文件直接在浏览器中生成，不会存储到 Supabase。',
		operationsSearchPlaceholder: '搜索名称、ID、品牌、分类或链接',
		operationsAllBrands: '所有品牌',
		operationsAllCategories: '所有分类',
		operationsMinPrice: '最低价格',
		operationsMaxPrice: '最高价格',
		operationsMatched: '匹配 {count} 项',
		operationsIssuesTitle: '商品质量结果',
		operationsIssuesDescription: '表格最多显示 100 项，下载文件包含所有匹配项。',
		operationsProduct: '商品',
		operationsBrand: '品牌',
		operationsIssues: '问题',
		operationsAction: '操作',
		operationsUnnamed: '未命名商品',
		operationsNoIssues: '没有问题',
		operationsEdit: '编辑',
		operationsNoMatches: '没有符合筛选条件的商品。',
		operationsTableLimit: '此处仅显示前 100 项，下载文件仍包含所有匹配项。',
		operationsConvertTitle: '联盟链接测试',
		operationsConvertDescription: '调用现有转换服务，不会保存任何商品更改。',
		operationsConvert: '测试链接',
		operationsConverting: '测试中...',
		operationsConvertResult: '转换结果',
		operationsConvertEmpty: '转换服务没有返回链接。',
		operationsConvertError: '链接转换失败。',
		operationsCopy: '复制',
		operationsCopied: '转换结果已复制。',
		operationsIssueAll: '所有商品',
		operationsIssueMissingName: '缺少名称',
		operationsIssueMissingBrand: '缺少品牌',
		operationsIssueMissingLink: '缺少商品链接',
		operationsIssueMissingPrice: '缺少价格',
		operationsIssueMissingCategory: '缺少分类',
		operationsIssueMissingImage: '缺少图片',
		operationsIssueInvalidPrice: '无效价格',
		operationsIssueDuplicateName: '重复名称',
		operationsIssueDuplicateLink: '重复微店链接',
		operationsIssueDuplicateOrder: '重复排序值',
		operationsIssueMissingAffiliates: '缺少联盟链接',
		navSearchSuggestions: '搜索建议',
		creatorsTitle: '创作者代码',
		creatorsDescription: '创建并管理唯一的邀请代码，以衡量每位内容创作者带来的流量和互动。',
		creatorCreateTitle: '创建创作者代码',
		creatorCreateDescription: '代码为小写，3-32 个字符（字母、数字、连字符、下划线）。将生成的链接分享给创作者。',
		creatorCodeLabel: '代码',
		creatorCodePlaceholder: '例如 jane01',
		creatorCodeHint: '小写字母、数字、连字符或下划线。3-32 个字符。',
		creatorLabelLabel: '标签（可选）',
		creatorLabelPlaceholder: '创作者名称或备注',
		creatorCreate: '创建代码',
		creatorCreating: '创建中...',
		creatorCreated: '创作者代码已创建',
		creatorInvalidFormat: '创作者代码必须为 3-32 个字符，仅限小写字母、数字、连字符或下划线。',
		creatorListTitle: '创作者代码',
		creatorListDescription: '启用或禁用代码并复制可分享链接。禁用仅停止后续归因；已归因的历史事件保持不变。',
		creatorRefresh: '刷新',
		creatorTableCode: '代码',
		creatorTableLabel: '标签',
		creatorTableStatus: '状态',
		creatorTableCreated: '创建时间',
		creatorTableUpdated: '更新时间',
		creatorTableShare: '分享链接',
		creatorTableFilters: '筛选',
		creatorCopyLink: '复制分享链接',
		creatorLinkCopied: '分享链接已复制',
		creatorCopyFailed: '无法复制链接',
		creatorEnabled: '已启用',
		creatorDisabled: '已禁用',
		creatorEnabledToast: '创作者代码已启用',
		creatorDisabledToast: '创作者代码已禁用',
		creatorSave: '保存',
		creatorSaved: '标签已更新',
		creatorUpdateFailed: '更新创作者代码失败',
		creatorLoadFailed: '加载创作者代码失败',
		creatorEmptyDescription: '尚无创作者代码。在上方创建一个以开始归因流量。',
		creatorAnalyticsTitle: '创作者分析',
		creatorAnalyticsDescription: '针对每个创作者代码的全漏斗第一方归因：会话、页面浏览量以及下游目录互动。',
		creatorDisclaimerTitle: '如何解读这些数据',
		creatorDisclaimerServerEntries: '服务器入口指标统计通过 /c/ 链接进入的有效访问。可识别的预览和机器人会被排除，但复杂机器人仍可能被计入。',
		creatorDisclaimerFirstParty: '浏览器会话与下游互动指标为浏览器观测的第一方分析数据。',
		creatorDisclaimerBrowserGap: '当分析被拦截或访客在页面加载前离开时，浏览器归因数据可能低于服务器入口数据。',
		creatorDisclaimerRedirects: '购物代理跳转分析与创作者入口流量保持独立。',
		creatorDisclaimerPurchases: '暂无购买和收入数据。',
		creatorMetricServerEntrySessions: '服务器入口会话',
		creatorMetricServerEntrySessionsDescription: '通过创作者 /c/ 链接观测到的不同浏览器会话 Cookie 数。',
		creatorMetricServerEntrySessionSum: '各创作者入口会话合计',
		creatorMetricServerEntrySessionSumDescription: '各创作者行的会话数相加；同一浏览器访问多个创作者链接时可能被分别计入。',
		creatorMetricServerEntryRequests: '服务器入口请求',
		creatorMetricServerEntryRequestsDescription: '经过短时重复抑制后接受的创作者链接请求数。',
		creatorMetricSessions: '归因会话',
		creatorMetricSessionsDescription: '使用已启用创作者代码进入的不同浏览器会话数。',
		creatorMetricPageViews: '页面浏览量',
		creatorMetricPageViewsDescription: '归因会话在各公共页面产生的第一方页面浏览量。',
		creatorMetricProductClicks: '商品点击',
		creatorMetricProductClicksDescription: '归因会话产生的商品链接和图片点击。',
		creatorMetricAffiliateClicks: '联盟点击',
		creatorMetricAffiliateClicksDescription: '归因会话产生的代理按钮点击（点击，非已确认销售）。',
		creatorChartTitle: '按归因会话排名的创作者',
		creatorChartDescription: '所选时间范围内带来最多不同会话的创作者。',
		creatorTablePerformanceTitle: '创作者表现',
		creatorTablePerformanceDescription: '会显示没有活动的已启用创作者，以便区分“暂无流量”和未配置。',
		creatorStatusUnregistered: '未注册',
		creatorEmptyTitle: '尚无创作者代码',
		creatorReportEmptyDescription: '创建创作者代码并分享其链接，即可开始收集归因流量。',
		creatorNoActivityYet: '此时间范围内暂无归因活动。',
		creatorTableAgents: '代理覆盖',
		creatorConfigureAgents: '配置代理',
		creatorAgentDialogTitle: '代理联盟覆盖 — {code}',
		creatorAgentDialogDescription: '为该创作者设置每个代理的联盟代码。只有已启用且代码有效的覆盖才会替换 ALI Officials 默认值；其他代理保持默认。联盟代码在服务器端解析。',
		creatorPreferredAgentLabel: '首选默认代理',
		creatorPreferredAgentHint: '当访客通过该创作者进入且尚未选择代理时自动选择。与同一代理的已启用覆盖搭配使用效果最佳。',
		creatorPreferredAgentNone: '无偏好',
		creatorAgentColumn: '代理',
		creatorAgentCodeColumn: '联盟代码',
		creatorAgentEnabledColumn: '启用覆盖',
		creatorAgentCodePlaceholder: '创作者联盟代码',
		creatorAgentSaved: '代理覆盖已保存',
		creatorAgentInvalidCode: '联盟代码必须为 1-64 个字符，仅限字母、数字、连字符或下划线。',
		creatorAgentEnabledNeedsCode: '启用该代理覆盖前请先输入联盟代码。',
		creatorPreferredNeedsOverride: '提示：首选代理没有已启用的联盟覆盖，将回退到 ALI Officials 默认代码。',
		creatorCancel: '取消',
		creatorSaveChanges: '保存更改',
		creatorSaving: '保存中...',
		dashboardLoading: '正在加载仪表盘数据...',
		dashboardCatalogLoadFailed: '加载目录数据失败',
		analyticsLoadFailed: '加载分析数据失败',
		analyticsBusinessOverview: '业务概览',
		analyticsBusinessOverviewDescription: '来自已批准 Analytics V1 RPC 的第一方互动指标。',
		analyticsCatalogOverview: '目录概览',
		analyticsCatalogOverviewDescription: '当前商品库存和最近新增内容。',
		analyticsDateRange: '分析日期范围',
		analyticsUtcRange: 'UTC 范围：{range}',
		analyticsPriorUtcRange: '上一对比 UTC 范围：{range}',
		analyticsComparedWithPrior: '对比上一周期',
		analyticsComparisonNew: '新增',
		analyticsComparisonNoBaseline: '无上一基线',
		analyticsLoading: '正在加载分析数据...',
		analyticsErrorTitle: '分析不可用',
		analyticsRetry: '重试',
		analyticsRefresh: '刷新',
		analyticsAutoRefreshHint: '实时 — 自动更新',
		analyticsNoEventsTitle: '暂无事件',
		analyticsNoEventsDescription: '此日期范围内没有返回第一方分析事件。',
		analyticsNoProductEventsDescription: '此日期范围内没有返回商品点击事件。',
		analyticsNoDiscoveryEventsDescription: '此日期范围内没有返回搜索、筛选或供给状态事件。',
		analyticsNoReliabilityEventsDescription: '此日期范围内没有返回服务器观测到的跳转事件。',
		analyticsAffiliateClicks: '推广点击',
		analyticsAffiliateClicksDescription: '客户端观测到的已启用代理推广按钮点击。',
		analyticsBrowserAffiliateClicks: '浏览器推广点击',
		analyticsBrowserAffiliateClicksDescription: '浏览器观测到的推广按钮点击，这与服务器观测到的跳转请求不同。',
		analyticsAgentSelections: '代理选择',
		analyticsAgentSelectionsDescription: '买家在公开目录中选择代理的次数。',
		analyticsTopClickedAgent: '最高点击代理',
		analyticsTopClickedAgentDescription: '按推广点击事件排序，不代表购买或确认转化。',
		analyticsTopSelectedAgent: '最高选择代理',
		analyticsTopSelectedAgentDescription: '按点击发生前的代理选择事件排序。',
		analyticsZeroResultRate: '零结果率',
		analyticsZeroResultRateDescription: '零结果搜索数除以总的已清洗搜索事件数。',
		analyticsFeedStatus: '供给状态',
		analyticsFeedStatusHealthy: '未见失败',
		analyticsFeedStatusWarning: '发现失败',
		analyticsFeedStatusUnknown: '无信号',
		analyticsFeedStatusHealthyDescription: '此范围内未捕获商品供给失败事件。',
		analyticsFeedStatusWarningDescription: '捕获到一个或多个商品供给失败事件。',
		analyticsFeedStatusUnknownDescription: '此范围内没有第一方事件，因此供给健康状态未验证。',
		analyticsAgentsTitle: '代理分析',
		analyticsAgentsDescription: '对比已选择代理意图与已点击代理行为。',
		analyticsClicksByAgent: '按代理统计推广点击',
		analyticsClicksByAgentDescription: '按已点击代理分组的客户端观测推广点击。',
		analyticsSelectionShare: '代理选择占比',
		analyticsSelectionShareDescription: '来自 agent_selected 事件的代理选择占比。',
		analyticsAgentRanking: '代理排行',
		analyticsAgentRankingDescription: '选择和点击是不同信号，不应视为转化。',
		analyticsAgent: '代理',
		analyticsSelectedShare: '选择占比',
		analyticsSelections: '选择数',
		analyticsClickedShare: '点击占比',
		analyticsClicks: '点击数',
		analyticsProductsTitle: '商品分析',
		analyticsProductsDescription: '使用有界名称和类别补充来排行商品点击活动。',
		analyticsProductClicks: '商品点击',
		analyticsProductClicksDescription: '客户端观测到的商品链接打开。商品曝光尚不可用。',
		analyticsTopClickedProduct: '最高点击商品',
		analyticsTopClickedProductDescription: '按所选范围内的商品点击次数排序。',
		analyticsNoCtrTitle: 'CTR 延后',
		analyticsCountsOnly: '仅计数',
		analyticsNoCtrDescription: '商品曝光已延后，因此此 MVP 不显示商品 CTR。',
		analyticsTopProductsChart: '最高点击商品',
		analyticsTopProductsChartDescription: '可用时按补充后的商品名称展示商品点击次数。',
		analyticsProductRanking: '商品排行',
		analyticsProductRankingDescription: '通过一次有界 db 查询补充了 {count} 个商品。',
		analyticsProduct: '商品',
		analyticsDiscoveryTitle: '发现分析',
		analyticsDiscoveryDescription: '来自已清洗第一方事件的搜索和筛选聚合。',
		analyticsSearches: '搜索',
		analyticsSearchesDescription: '买家停止输入后捕获的已清洗搜索事件。',
		analyticsTopSearch: '热门搜索',
		analyticsTopSearchDescription: '此范围内最常见的已清洗搜索词。',
		analyticsTopMissedDemand: '最高未满足需求',
		analyticsTopMissedDemandDescription: '最常见的已清洗零结果搜索词。',
		analyticsTopSearches: '热门已清洗搜索',
		analyticsTopSearchesDescription: '搜索词在存储前会被截断和脱敏。',
		analyticsFilterUsage: '类别和筛选使用',
		analyticsFilterUsageDescription: '按类别或筛选维度统计 filter_applied 事件。',
		analyticsFilterEvents: '筛选事件',
		analyticsNoSearchesTitle: '无搜索',
		analyticsNoSearchesDescription: '此范围内没有返回已清洗搜索词。',
		analyticsNoFiltersTitle: '无筛选使用',
		analyticsNoFiltersDescription: '此范围内没有返回 filter_applied 事件。',
		analyticsMissedDemand: '未满足需求搜索',
		analyticsMissedDemandDescription: '返回零结果的已清洗搜索。',
		analyticsFeedAndErrors: '供给和客户端信号',
		analyticsFeedAndErrorsDescription: '商品供给失败和抽样客户端错误聚合。',
		analyticsFeedFailurePrefix: '供给失败',
		analyticsClientErrorPrefix: '客户端错误',
		analyticsSearchTerm: '搜索词',
		analyticsZeroResultSearches: '零结果搜索',
		analyticsSignal: '信号',
		analyticsEvents: '事件',
		analyticsNoRowsTitle: '无行',
		analyticsNoRowsDescription: '此部分没有返回聚合行。',
		analyticsReliabilityTitle: '可靠性分析',
		analyticsReliabilityDescription: '来自 affiliate 跳转 API 的服务器观测跳转请求与失败。',
		analyticsReliabilityNote: '浏览器观测推广点击、服务器观测跳转请求、跳转失败以及已确认第三方购买是不同信号。已确认购买仍不可用。',
		analyticsRedirectRequests: '跳转请求',
		analyticsRedirectRequestsDescription: '服务器观测到并成功生成第三方跳转响应的请求。',
		analyticsRedirectFailures: '跳转失败',
		analyticsRedirectFailuresDescription: '返回非跳转 API 失败响应的跳转请求。',
		analyticsRedirectFailureRate: '跳转失败率',
		analyticsRedirectFailureRateDescription: '服务器观测跳转失败数除以跳转请求总数。',
		analyticsConfirmedPurchases: '已确认购买',
		analyticsConfirmedPurchasesDescription: '此分析系统无法获取第三方购买确认。',
		analyticsUnavailable: '不可用',
		analyticsRedirectRequestsByAgent: '按代理统计跳转请求',
		analyticsRedirectRequestsByAgentDescription: '按请求代理路由分组的服务器观测跳转响应。',
		analyticsRedirectFailuresByStatus: '按状态统计跳转失败',
		analyticsRedirectFailuresByStatusDescription: '跳转生成失败时返回的 HTTP 状态码。',
		analyticsRedirectFailuresByAgent: '按代理统计跳转失败',
		analyticsRedirectFailuresByAgentDescription: '与失败跳转响应相关的代理。',
		analyticsRedirectFailuresByMarketplace: '按平台统计跳转失败',
		analyticsRedirectFailuresByMarketplaceDescription: '与失败跳转响应相关的商品平台。',
		analyticsRedirectFailuresByStage: '按阶段统计跳转失败',
		analyticsRedirectFailuresByStageDescription: '来自跳转处理器的失败阶段分组。',
		analyticsMarketplace: '平台',
		analyticsFailureStage: '失败阶段',
		cloudflareTitle: 'Cloudflare 流量指标',
		cloudflareDescription: 'Cloudflare 观测到的公开站点 HTTP 流量。与下方的第一方站点事件独立加载。',
		cloudflareFetching: '正在获取 Cloudflare 分析数据...',
		cloudflareLoaded: 'Cloudflare 分析已加载',
		cloudflareLoadFailed: '加载 Cloudflare 分析数据失败',
		cloudflareCorsToast: '无法从此浏览器加载 Cloudflare 分析。',
		cloudflareCorsMessage: '浏览器安全限制（CORS）。Cloudflare 分析不可用。',
		cloudflareRefresh: '刷新 Cloudflare 分析',
		cloudflareErrorTitle: 'Cloudflare 不可用',
		cloudflareUnavailableTitle: 'Cloudflare 分析尚未配置',
		cloudflareUnavailableDescription: '设置 Cloudflare 边缘函数密钥后即可启用此流量卡片。第一方分析仍可使用。',
		cloudflareCorsDetail: 'Cloudflare 不可用时，第一方分析仪表盘仍可使用。',
		cloudflarePageViews: '页面浏览量',
		cloudflareVisits: '访问次数',
		cloudflareUniqueVisitors: '独立访客',
		cloudflarePageViewsDefinition: 'Cloudflare 在所选 UTC 时间范围内统计的页面浏览量。',
		cloudflareVisitsDefinition: 'Cloudflare 在所选 UTC 时间范围内统计的访问次数，基于终端用户 eyeball 流量聚合。',
		cloudflareUniqueVisitorsDefinition: 'Cloudflare 在所选 UTC 时间范围内统计的独立访客。多日合计会将每日值相加。',
		cloudflareInfrastructureRequests: '边缘请求数（基础设施）',
		cloudflareInfrastructureDefinition: '经 Cloudflare 的全部 HTTP 请求，含静态资源、机器人和平台流量。不是访客指标。',
		cloudflareTotalRequests: '总请求数',
		cloudflareRequests: '请求数',
		cloudflareTopCountries: '热门国家',
		cloudflareDateWindow: 'UTC 范围：{start} 至 {end}',
		cloudflareLastRange: '最近 {range}',
		cloudflareTrendsTitle: '流量趋势',
		cloudflareNoPageViews: '此期间没有页面浏览数据',
		cloudflareNoVisits: '此期间没有访问次数数据',
		cloudflareNoUniqueVisitors: '此期间没有独立访客数据',
		cloudflareNoCountries: '此期间没有国家数据',
		cloudflareNoData: '没有可用的 Cloudflare 分析数据',
		cloudflareMetricSource: '来源：Cloudflare 区域分析（GraphQL）',
	},
};


